import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);    
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

function list(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir'];

            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            const url = `/dimension${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            resolve(list);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
}

function update(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const obj = {DimColName: data.DimColName, DimColDesc: data.DimColDesc, Caption: data.Caption, FilterCap: data.FilterCap, DimSequence: data.DimSequence, isUsed: data.isUsed} ;
            await axios.put(`dimension/${data.kodelama}`, obj);
            resolve();
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}

function validate(datadim) {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get(`/dimension/validate`, datadim);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}

function exportXls(obj = {}) {
        const keys = ['tahun', 'DimColName', 'DimColDesc'];

        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/coa/exportxls${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'coa.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
        
}
function dimsetup() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/dimsample/dimsetup");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}

export default { list, update, validate, exportXls, dimsetup };